import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';
import {
  IndexListingsScreen,
  IndexListingsScreenProps,
} from 'shared/screens/listings/index-listings';
import { Page } from '@web/components/page';
import { shouldNoIndexListingsFilter } from 'shared/state/listings-filter';
import { useListingIndexResults } from '@web/library/use-listing-index-results';

export default function IndexListings(serverProps: IndexListingsScreenProps) {
  const props = useListingIndexResults(serverProps);
  const { t } = useTranslation('screens');

  const title = t('listings.index_listings.title');

  const description = t('listings.index_listings.description');

  const shouldNoIndex = shouldNoIndexListingsFilter(props.initialFilter);

  return (
    <Page
      {...props}
      register={(seo) => {
        const pageSeo = seo
          .setTitle(title)
          .setDescription(description)
          .setPagination(props.initialListings);

        return shouldNoIndex ? pageSeo.setNoIndex() : pageSeo;
      }}
    >
      <IndexListingsScreen title={title} subtitle={description} {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(IndexListingsScreen.pageBuilder);
